import React from "react";
import Grid from "@material-ui/core/Grid";
import KeyItem from "./KeyItem";
import numberCharacters from "../../util/keyboard/numbers.json";

function NumericKeyboard(props) {
  var keyboard = numberCharacters.numbers;

  return (
    <div>
      <Grid id="NumericKeyboard" container>
        {keyboard.map((keys, index) => (
          <Grid
            key={index}
            item
            container
            xs={12}
            style={{
              padding: 5,
            }}
            justifyContent="space-around"
            alignItems="stretch"
          >
            {keys.map((characters, index) => (
              <Grid item xs={characters.noofcolumns} key={index}>
                <KeyItem
                  alphabet={characters.letter}
                  onClick={props.onClick}
                  idVal={characters.id}
                  marginLeft={characters.marginLeft}
                />
              </Grid>
            ))}
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default NumericKeyboard;
